import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../../../authentication.service';
import {HttpClient, HttpEvent, HttpEventType} from '@angular/common/http';
import {GlobalService} from '../../../global.service';
import {teamsService} from '../teams.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'elastic-edit-team',
  templateUrl: './edit-team.component.html',
  styleUrls: ['./edit-team.component.scss']
})
export class EditTeamComponent implements OnInit {

  team = {
    team_id: 0,
    teamname : '',
    teamwebsite: '',
    join_password: '',
    teamfacebook: '',
    teamtwitch: '',
    teamyoutube: '',
    teamdiscord: '',
    teamtwitter: '',
    teaminstagram: '',
    teamspeak: '',
    description: '',
    members: []
  };

  teamId: any = 0;
  amIAdmin = false;
  fileToUpload: any;
  edit = false;
  newTeam = true;
  countrySearch: string;

  constructor(private router: Router, private route: ActivatedRoute, private cdr: ChangeDetectorRef, private auth: AuthenticationService, private httpClient: HttpClient, private globalService: GlobalService, private teamsService: teamsService) { }

  ngOnInit() {
    this.fileToUpload = false;

    if (this.route.snapshot.paramMap.get('id')) {
      this.teamId = this.route.snapshot.paramMap.get('id');
      this.edit = true;
      this.newTeam = false;
    }


    if (this.teamId !== 0) {
      this.teamsService.getEditTeam(this.teamId).subscribe(
        ( response: HttpEvent<any> ) => {
          switch (response.type) {
            case HttpEventType.Response:
              this.team = response.body.data;
              this.team.members.forEach((item) => {
                if (item.id*1 === this.auth.getUserId()*1) {
                  this.amIAdmin = true;
                }
              });

              this.cdr.detectChanges();
              break;
          }
        });
    }

  }

  handleLogo(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  save() {

    this.teamsService.saveTeam(this.team, this.fileToUpload).subscribe(
      ( response: HttpEvent<any> ) => {
        switch (response.type) {
          case HttpEventType.Response:
            if (response.body) {
              this.router.navigate(['/teams/detail/', response.body.team_id]);
            }
            this.cdr.detectChanges();
            break;
        }
      });







  }

}
